module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.16e1d930cf13fb7a9563.woff";


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/assets/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff
// module id = ../../../../../src/assets/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff
// module chunks = styles